import { BrowserRouter, Route, Routes } from 'react-router';
import { Shell } from './components/Shell';
import { Stores } from './pages/Stores';
import { Catalog } from './pages/Catalog';
import { Purchases } from './pages/Purchases';
import { Manage } from './pages/staff/Manage';
import { Statistics } from './pages/staff/Statistics';
import { People } from './pages/owner/People';
import { Danger } from './pages/owner/Danger';

/**
 * Routes are a convenience, not a permission boundary.
 *
 * Every one of these screens calls an endpoint that re-checks authorisation
 * server-side, because hiding a nav link is not access control — a user who
 * types /people gets a 403 from the API, not a rendered page.
 */
export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Shell />}>
          <Route index element={<Stores />} />
          <Route path="store/:storeId" element={<Catalog />} />
          <Route path="purchases" element={<Purchases />} />
          <Route path="manage" element={<Manage />} />
          <Route path="statistics" element={<Statistics />} />
          <Route path="people" element={<People />} />
          <Route path="danger" element={<Danger />} />
          <Route path="*" element={<Stores />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
